import { gql } from 'urql';
import { PRODUCT } from '../client';

export const UPDATE_LOCATIONS_CUSTOMER_PICKUP = gql`
  mutation ${PRODUCT}UpdateLocationsCustomerPickup($input: LocationsCustomerPickupUpdateInput!) {
    updateLocationsCustomerPickup(input: $input) {
      locations {
        id
        customerPickup
      }
      notFoundLocationIds
      userErrors {
        __typename
        ... on UserErrorInterface {
          message
        }
        ... on RecentDeliveriesPresent {
          offenders {
            locationId
            name
            stopCount
            lastNightEnd
          }
        }
      }
    }
  }
`;
